import { SyncOutlined } from "@ant-design/icons";
import { Tag } from "antd";

export const EnviadoTag = ({ icon, text = null, ...restProps }) => {
  return (
    <Tag color="green-inverse" {...restProps}>
      {icon ? icon : <SyncOutlined spin />}
      {text === null ? " Enviado" : text}
    </Tag>
  );
};
